import styled from 'styled-components';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const styledImage = () => styled.img;
